// extracted by mini-css-extract-plugin
module.exports = {"phoneLink":"amacSupportLink_phoneLink__P2xBf"};